import { render, staticRenderFns } from "./BlipOpenTicketsTable.vue?vue&type=template&id=8ef8f27e&scoped=true&"
import script from "./BlipOpenTicketsTable.vue?vue&type=script&lang=js&"
export * from "./BlipOpenTicketsTable.vue?vue&type=script&lang=js&"
import style0 from "./BlipOpenTicketsTable.vue?vue&type=style&index=0&id=8ef8f27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef8f27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
